<section class="container-style">
    <form [formGroup]="formReverse">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 fw-bold mb-1">
                <label>Para revertir el proceso de importación de cotizaciones, seleccione la Compañía y
                    Sucursal:</label>
            </div>
            <div class="row">
                <div class="col">
                    <app-custom-autocomplete formControlName="companyId" [labelText]="'Compañía'" [list]="listCompanies"
                        [required]="true" [recovery]="true" (onChangeSelect)="getCompany($event)">
                    </app-custom-autocomplete>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-custom-autocomplete formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                        [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event)">
                    </app-custom-autocomplete>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-custom-autocomplete formControlName="typeId" [labelText]="'Tipo'" [list]="listTypes"
                        [required]="true" [recovery]="true" (onChangeSelect)="getType($event)">
                    </app-custom-autocomplete>
                </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-md-3">
                <app-custom-button [label]="'Revertir'" [severity]="'primary'" [variant]="undefined"
                    (onClick)="revertImportPendingsOrders()"></app-custom-button>
            </div>
        </div>
        <div class="row">
            <div id="list" *ngIf="visibleTxt">
                <h6>Lista de Errores y Alertas</h6>
                <div id="container-alerts" *ngFor="let revertOrderAlert of revertOrdersAlerts">
                    <p [ngClass]="errorRevertOrder == 1 ? 'message-error' : 'message-alert'">
                        {{revertOrderAlert.message}}
                    </p>
                </div>
            </div>
            <div class="row" *ngIf="visibleTxt">
                <div class="d-flex justify-content-end">
                    <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'"
                        [width]="'5.5rem'" (onClick)="downloadErrorsTxt()"></app-custom-button>
                </div>
            </div>
        </div>
    </form>
</section>